import * as React from 'react';

import {MODAL_CHAT_INIT_PROGRESS} from '~/rootStore/modals/modalsIds';
import useModalById from '~/customHooks/useModalById';

import ModalBase from '../ModalBase';
import ModalBaseContent from '../ModalBaseContent';

const ModalChatInitProgress: React.FC = () => {
  const {isOpen, close} = useModalById(MODAL_CHAT_INIT_PROGRESS);

  return (
    <ModalBase open={isOpen} onClose={() => close()}>
      <ModalBaseContent p={2} title="Chat initialization..." description="Wait a second please." />
    </ModalBase>
  );
};

export default ModalChatInitProgress;
